import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useStateIfMounted } from "use-state-if-mounted";
import useFetchData from "../../../../hooks/useFetchData";
import { DEFAULT_METER_INFO_STATE } from "./MetersConstants";

export const useBasicMeterInfo = (selectedMeter) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_METER_INFO_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };

      if (name === "retired_date") {
        newFilterValues["is_active"] = !value;
      }

      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedMeter) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_METER_INFO_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-meters", selectedMeter],
    async () => {
      if (!selectedMeter) {
        setIsDirty(false);
        setEditorState(DEFAULT_METER_INFO_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-meters/${selectedMeter}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [setupWellLookup] = useFetchData(
    "ui-list-meter-well-records",
    [],
    true
  );

  const [metersLookup] = useFetchData(
    "ui-meters-management-top-table",
    [],
    true
  );

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      setupWell: setupWellLookup,
      meters: metersLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
